import React, { useContext, useEffect } from "react";
import { ResultContext, TimeType } from "../ResultContext";
import { LampSuggestion } from "../components/LampSuggestion";

export function VestingDurationInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const foundResult = (result[questionId] as {
    time: number;
    type: TimeType;
  }) || { time: 1, type: TimeType.Year };

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = { time: 1, type: TimeType.Year };

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  return (
    <div className="flex flex-column">
      <label>Vesting period</label>
      <div className="flex items-center">
        <select
          value={foundResult.time}
          onChange={(e) => {
            const copy = { ...result };

            copy[questionId] = {
              ...foundResult,
              time: parseFloat(e.target.value),
            };

            setResult(copy);
          }}
        >
          {Array.from(Array(10).keys()).map((item, index) => {
            return (
              <option value={item + 1} key={index}>
                {item + 1}
              </option>
            );
          })}
        </select>
        <div className="ml-4">Year{foundResult.time !== 1 ? "s" : null}</div>
      </div>
      <LampSuggestion
        text={
          "On average a vesting period of 4 years is common. The shorter the vesting period, the weaker the commitment towards each other and the company."
        }
      />
    </div>
  );
}
